<mat-toolbar color="accent"> Patient Marketing Campaigns </mat-toolbar>
<mat-dialog-content class="!p-0 !text-black">
  <mat-tab-group class="h-full w-full">
    <mat-tab label="Active Campaigns">
      <div class="flex flex-col gap-4 p-4">
        <ng-container [ngTemplateOutlet]="tabHeader" />
        @for (entry of activeEntries$ | async; track entry.ref.path) {
          <pr-patient-marketing-campaign [entry]="entry" />
        } @empty {
          <pr-empty-state image="list" title="Active Campaigns" />
        }
      </div>
    </mat-tab>
    <mat-tab label="Past Campaigns">
      <div class="flex flex-col gap-4 p-4">
        <ng-container [ngTemplateOutlet]="tabHeader" />
        @for (entry of pastEntries$ | async; track entry.ref.path) {
          <pr-patient-marketing-campaign [entry]="entry" />
        } @empty {
          <pr-empty-state image="list" title="Past Campaigns" />
        }
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<div mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Close</button>
</div>

<ng-template #tabHeader>
  @if (data.patient.metadata?.receiveMarketing === false) {
    <pr-information-box>
      Patient has opted-out of Marketing Communications
    </pr-information-box>
  }
</ng-template>
